import { DocumentRelationObject } from '../../../types';
import { ConstructDelete } from '../../types/ConstructDelete';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const deleteDocumentRelation = async (
  constructDelete: ConstructDelete,
  documentId: string,
  documentParams: DocumentParams,
  data: DocumentRelationObject,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructDelete(
    `${DOCUMENTS_BASE_PATH}/${documentId}/related/delete`,
    { data, headers: buildHeadersFromDocumentParams(documentParams) },
    { preventDefaultErrorToast: true },
  );
